module.exports = __webpack_public_path__ + "img/117.e9ded3ed.png";